import { useEffect } from 'react';

import Seo from '../../seo/Seo';
import { STATIC_META } from '../../seo/metaConfig';
import { About } from '../Home/components/About';
import { Measure } from '../Home/components/Measure';
import { Delivery } from '../Home/components/Delivery';

// Отдельный адрес /about для блока о компании: тот же контент, что и на главной,
// но со своими Title и Description.
export const AboutPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Seo {...STATIC_META.about} />
      <About />
      <Measure />
      <Delivery />
    </>
  );
};
